<template>
    <div>
        <div class="modal fade" id="OrderCreatorModal" ref="modalEle" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" :class="productViewMode === 'details' ? 'modal-xl' : 'modal-full-width'" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Kreator zamówienia stali</h5>
                        <button
                            type="button"
                            class="close ms-auto"
                            data-bs-dismiss="modal"
                            aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">

                        <div class="row mb-4">
                            <div class="col-12">
                                <label class="form-label">Plik XLSX</label>
                                <div class="d-flex align-items-center gap-2">
                                    <input
                                        ref="fileInput"
                                        type="file"
                                        class="form-control"
                                        style="max-width: 400px;"
                                        accept=".xlsx"
                                        @change="file = $event.target.files[0] || null" />

                                    <button
                                        type="button"
                                        class="btn btn-primary flex-shrink-0"
                                        :disabled="importingFile || !file"
                                        @click="importFile">

                                        <span
                                            v-if="importingFile"
                                            class="spinner-border spinner-border-sm me-2"
                                            role="status"></span>

                                        <i
                                            v-else
                                            class="bi bi-upload me-2"></i>

                                        {{ importingFile ? 'Wczytywanie...' : 'Wczytaj plik' }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-4">

                            <div
                                v-if="files.length"
                                class="col-12 mb-4">
                                <label class="form-label">Wczytane pliki</label>

                                <div class="table-responsive">
                                    <table class="table table-bordered table-sm align-middle mb-0">
                                        <thead>
                                            <tr>
                                                <th>Nazwa pliku</th>
                                                <th style="width: 180px;">
                                                    Data dodania
                                                </th>
                                                <th style="width: 180px;">
                                                    Akcje
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr
                                                v-for="item in files"
                                                :key="item.id">
                                                <td>
                                                    {{ item.file_name }}
                                                </td>

                                                <td>
                                                    {{ formatFileDate(item.created_at) }}
                                                </td>

                                                <td>
                                                    <div class="d-flex gap-2">
                                                        <button
                                                            v-if="selectedCategory && selectedArticle"
                                                            type="button"
                                                            class="btn btn-sm btn-primary"
                                                            :disabled="loadingFile === item.id"
                                                            @click="loadFile(item.id)">
                                                            <span v-if="loadingFile === item.id" class="spinner-border spinner-border-sm me-1"></span>
                                                            <i v-else class="bi bi-folder2-open me-1"></i>
                                                            Wczytaj
                                                        </button>
                                                        <button
                                                            type="button"
                                                            class="btn btn-sm btn-danger"
                                                            :disabled="deletingFile === item.id"
                                                            @click="deleteFile(item.id)">
                                                            <span v-if="deletingFile === item.id" class="spinner-border spinner-border-sm me-1"></span>
                                                            <i v-else class="bi bi-trash me-1"></i>
                                                            Usuń
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <label class="form-label">Kategoria</label>

                                <select
                                    v-model="selectedCategory"
                                    class="form-select"
                                    @change="loadArticles">
                                    <option value="">
                                        Wybierz kategorię
                                    </option>

                                    <option
                                        v-for="category in kreator_kategorie"
                                        :key="category.category_id"
                                        :value="category.category_id">
                                        {{ category.name }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-md-9">
                                <label class="form-label">Artykuł</label>

                                <div class="dropdown">
                                    <button
                                        type="button"
                                        class="form-select text-start"
                                        :disabled="!selectedCategory || loadingArticles"
                                        data-bs-toggle="dropdown"
                                        data-bs-auto-close="true"
                                        @click="focusArticleSearch">
                                        {{ articleButtonLabel }}
                                    </button>

                                    <div class="dropdown-menu w-100 p-2">
                                        <input
                                            ref="articleSearchInput"
                                            v-model="articleSearch"
                                            type="text"
                                            class="form-control mb-2"
                                            placeholder="Wyszukaj artykuł..."
                                            autocomplete="off"
                                            @click.stop>

                                        <div style="max-height: 300px; overflow-y: auto;">
                                            <button
                                                v-for="article in filteredArticles"
                                                :key="article.id"
                                                type="button"
                                                class="dropdown-item text-wrap"
                                                @click="selectArticle(article)">
                                                {{ article.catalog_number }},
                                                {{ article.model }},
                                                {{ article.description }}
                                                {{ article.details }}
                                            </button>

                                            <div
                                                v-if="filteredArticles.length === 0"
                                                class="text-muted text-center py-2">
                                                Nie znaleziono artykułu.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            v-if="selectedArticle"
                            class="mt-3">
                            <h6 class="mb-3">Odcinki</h6>

                            <div class="table-responsive">
                                <table class="table table-bordered table-sm">
                                    <thead>
                                        <tr>
                                            <th style="width: 70px;">#</th>
                                            <th>
                                                Długość w mm (bez naddatków)
                                            </th>
                                            <th>Ilość szt.</th>
                                            <th style="width: 55px;"></th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr
                                            v-for="(item, index) in orderItems"
                                            :key="item.id">
                                            <td class="align-middle">
                                                {{ index + 1 }}
                                            </td>

                                            <td>
                                                <input
                                                    :ref="el => setLengthRef(el, index)"
                                                    v-model="item.length"
                                                    type="number"
                                                    min="1"
                                                    step="1"
                                                    class="form-control"
                                                    placeholder="Długość"
                                                    @keydown.tab="handleLengthTab(index, $event)">
                                            </td>

                                            <td>
                                                <input
                                                    :ref="el => setQuantityRef(el, index)"
                                                    v-model="item.quantity"
                                                    type="number"
                                                    min="1"
                                                    step="1"
                                                    class="form-control"
                                                    placeholder="Ilość"
                                                    @keydown.tab="handleQuantityTab(index, $event)">
                                            </td>

											<td class="text-center align-middle">
												<div class="d-flex justify-content-center gap-1">

													<button
														v-if="index === orderItems.length - 1"
														type="button"
														class="btn btn-sm btn-primary"
														title="Dodaj pozycję"
														@click="addOrderItem">
														<i class="bi bi-plus-lg"></i>
													</button>

													<button
														type="button"
														class="btn btn-sm btn-danger"
														title="Usuń pozycję"
														@click="removeOrderItem(index)">
														<i class="bi bi-trash"></i>
													</button>

												</div>
											</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div
                            v-if="saveMessage"
                            class="alert alert-success mt-3 mb-0">
                            <i class="bi bi-check-circle me-2"></i>
                            {{ saveMessage }}
                        </div>

                        <div
                            v-if="saveError"
                            class="alert alert-danger mt-3 mb-0">
                            <i class="bi bi-exclamation-triangle me-2"></i>
                            {{ saveError }}
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal">
                            <i class="bi bi-x-square me-2"></i>
                            Zamknij
                        </button>

                        <button
                            type="button"
                            class="btn btn-outline-success"
                            :disabled="generatingPdf"
                            @click="generateCuttingPlanPdf">
                            <span
                                v-if="generatingPdf"
                                class="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"></span>

                            <i
                                v-else
                                class="bi bi-file-earmark-pdf me-2"></i>

                            {{ generatingPdf ? 'Generowanie...' : 'Utwórz tylko rozkrój' }}
                        </button>

                        <button
                            type="button"
                            class="btn btn-primary"
                            :disabled="saving"
                            @click="saveOrder">
                            <span
                                v-if="saving"
                                class="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"></span>

                            <i
                                v-else
                                class="bi bi-save me-2"></i>

                            {{ saving ? 'Zapisywanie...' : 'Zapisz zapotrzebowanie' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            id="FileDataModal"
            ref="fileDataModalEle"
            tabindex="-1"
            aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title">
                            Odcinki z pliku
                        </h5>

                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Zamknij"></button>
                    </div>

                    <div class="modal-body">

                        <div
                            v-if="loadingFileData"
                            class="text-center py-4">
                            <div
                                class="spinner-border"
                                role="status"></div>

                            <div class="mt-2">
                                Wczytywanie odcinków...
                            </div>
                        </div>

                        <div
                            v-else-if="fileData.length"
                            class="table-responsive">
                            <table class="table table-bordered table-sm align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th style="width: 50px;" class="text-center">
                                            #
                                        </th>
                                        <th style="width: 120px;" class="text-center">
                                            Wybierz
                                        </th>
                                        <th>
                                            Typ
                                        </th>

                                        <th>
                                            Odcinki
                                        </th>


                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="(item, index) in fileData" :key="item.id">
                                       <td class="text-center">
											{{ index + 1 }}
										</td>
										<td class="text-center">
											<input
												v-model="selectedFileData"
												:value="item.id"
												type="checkbox"
												class="form-check-input"
												style="
													width: 22px;
													height: 22px;
													border: 2px solid #555;
													cursor: pointer;
												">
										</td>
                                        <td>
                                            {{ item.typ }}
                                        </td>

                                        <td>
                                            {{ item.odcinki_mm }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div
                            v-else
                            class="alert alert-info mb-0">
                            Brak odcinków w wybranym pliku.
                        </div>

                    </div>

                    <div class="modal-footer">

                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal">
                            Anuluj
                        </button>

                        <button
                            type="button"
                            class="btn btn-primary"
                            :disabled="!selectedFileData.length"
                            @click="useSelectedFileData">
                            <i class="bi bi-check-lg me-1"></i>
                            Użyj wybrane
                        </button>

                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {
        Modal
    } from "bootstrap";

    import axios from "axios";

    import {
        usePermission
    } from "@/composables/resources/js/composables/permissions.js";

    const {
        hasRole,
        hasPermission
    } = usePermission();

    export default {
        props: {
            project: [Number, String],

            team: {
                type: String,
                default: ''
            },

            liczba_maszyn: {
                type: Number,
                default: 1
            },

            kreator_kategorie: {
                type: Array,
                default: () => []
            },

            context: String
        },

        data() {
            return {
                file: null,
                importingFile: false,
                files: [],
                loadingFiles: false,
                loadingFile: null,
                deletingFile: null,
                fileData: [],
                selectedFileData: [],
                modalObj: null,
                fileDataModalObj: null,
                loadingFileData: false,
                articleSearch: '',
                hasPermission,
                generatingPdf: false,
                selectedCategory: '',
                selectedArticle: '',
                articles: [],
                loadingArticles: false,
                saving: false,
                saveMessage: '',
                saveError: '',
                orderItems: [{
                    id: 1,
                    length: '',
                    quantity: ''
                }],

                lengthRefs: [],
                quantityRefs: []
            };
        },

        computed: {
            articleButtonLabel() {
                if (this.loadingArticles) {
                    return 'Ładowanie...';
                }

                if (!this.selectedArticle) {
                    return 'Wybierz artykuł';
                }

                const article = this.articles.find(
                    article =>
                    String(article.id) === String(this.selectedArticle)
                );

                if (!article) {
                    return 'Wybierz artykuł';
                }

                return [
                        article.catalog_number,
                        article.model,
                        article.description,
                        article.details
                    ]
                    .filter(Boolean)
                    .join(', ');
            },

            filteredArticles() {
                const search = this.articleSearch.trim().toLowerCase();

                if (!search) {
                    return this.articles;
                }

                return this.articles.filter(article => [
                    article.catalog_number,
                    article.model,
                    article.description,
                    article.details
                ].some(value =>
                    String(value ?? '')
                    .toLowerCase()
                    .includes(search)
                ));
            }
        },

        mounted() {
            this.modalObj = new Modal(this.$refs.modalEle);

            this.fileDataModalObj = new Modal(
                this.$refs.fileDataModalEle
            );

            this.$refs.modalEle.addEventListener(
                'hide.bs.modal',
                () => {
                    this.resetForm();
                }
            );
        },
        methods: {
			removeOrderItem(index) {
				this.orderItems.splice(index, 1);

				if (!this.orderItems.length) {
					this.orderItems.push({
						id: Date.now() + Math.random(),
						length: '',
						quantity: ''
					});
				}

				this.$nextTick(() => {
					this.lengthRefs = [];
					this.quantityRefs = [];

					this.orderItems.forEach((item, index) => {
						const lengthInput = this.$refs[`length-${index}`];
						const quantityInput = this.$refs[`quantity-${index}`];
					});
				});
			},
            async loadFiles() {
                this.loadingFiles = true;

                try {
                    const response = await axios.post(
                        this.route('creator.files'), {
                            project_id: this.project,
                            team_name: this.team
                        }
                    );

                    this.files = response.data;

                } catch (error) {
                    this.files = [];
                } finally {
                    this.loadingFiles = false;
                }
            },

            useSelectedFileData() {
                const selectedRows = this.fileData.filter(
                    item => this.selectedFileData.some(
                        id => String(id) === String(item.id)
                    )
                );

                const positions = [];

                selectedRows.forEach(row => {
                    const parts = String(row.odcinki_mm || '')
                        .split(',')
                        .map(item => item.trim())
                        .filter(Boolean);

                    parts.forEach(part => {
                        const match = part.match(/^(\d+)\s*x\s*(\d+)$/i);

                        if (match) {
                            positions.push({
                                id: Date.now() + Math.random(),
                                length: Number(match[2]),
                                quantity: Number(match[1])
                            });

                            return;
                        }

                        const length = Number(
                            part.replace(',', '.')
                        );

                        if (Number.isFinite(length) && length > 0) {
                            positions.push({
                                id: Date.now() + Math.random(),
                                length: length,
                                quantity: 1
                            });
                        }
                    });
                });

                if (!positions.length) {
                    this.saveError =
                        'Nie znaleziono poprawnych odcinków w wybranych pozycjach.';

                    return;
                }

                this.orderItems = positions;

                this.selectedFileData = [];

                this.fileDataModalObj.hide();

                this.$nextTick(() => {
                    this.focusLength(0);
                });
            },

            async loadFile(fileId) {
                this.loadingFile = fileId;
                this.loadingFileData = true;
                this.selectedFileData = [];

                try {
                    const response = await axios.get(
                        this.route(
                            'creator.data.file',
                            fileId
                        )
                    );

                    this.fileData = response.data.data;

                    this.saveMessage = '';
                    this.saveError = '';

                    this.$nextTick(() => {
                        this.fileDataModalObj.show();
                    });

                } catch (error) {
                    this.saveError =
                        error.response?.data?.message ||
                        'Nie udało się wczytać pliku.';
                } finally {
                    this.loadingFile = null;
                    this.loadingFileData = false;
                }
            },

            async deleteFile(fileId) {
                if (!confirm('Czy na pewno chcesz usunąć ten plik?')) {
                    return;
                }

                this.deletingFile = fileId;

                try {
                    const response = await axios.delete(
                        this.route(
                            'creator.file.delete',
                            fileId
                        )
                    );

                    this.files = this.files.filter(
                        file => file.id !== fileId
                    );

                    this.fileData = [];

                    this.saveMessage = response.data.message;
                    this.saveError = '';

                } catch (error) {
                    this.saveError =
                        error.response?.data?.message ||
                        'Nie udało się usunąć pliku.';
                } finally {
                    this.deletingFile = null;
                }
            },
            formatFileDate(date) {
                if (!date) {
                    return '';
                }

                return new Date(date).toLocaleString('pl-PL');
            },

            async importFile() {
                this.saveMessage = '';
                this.saveError = '';

                if (!this.file) {
                    this.$emit(
                        'added-error',
                        'Wybierz plik XLSX.'
                    );

                    return;
                }

                this.importingFile = true;

                try {
                    const formData = new FormData();

                    formData.append('file', this.file);
                    formData.append('project_id', this.project);
                    formData.append('team_name', this.team);

                    const response = await axios.post(
                        this.route('creator.data.import-file'),
                        formData
                    );

                    await this.loadFiles();

                    this.file = null;

                    if (this.$refs.fileInput) {
                        this.$refs.fileInput.value = '';
                    }

                    this.saveMessage = response.data.message;
                    this.saveError = '';

                } catch (error) {
                    let message =
                        'Wystąpił błąd podczas wczytywania pliku.';

                    if (error.response?.data?.errors) {
                        message = Object.values(
                                error.response.data.errors
                            )
                            .flat()
                            .join(' ');
                    } else if (error.response?.data?.message) {
                        message = error.response.data.message;
                    }

                    this.saveError = message;

                    this.$emit(
                        'added-error',
                        message
                    );

                } finally {
                    this.importingFile = false;
                }
            },

            focusArticleSearch() {
                this.$nextTick(() => {
                    this.$refs.articleSearchInput?.focus();
                });
            },

            selectArticle(article) {
                this.selectedArticle = article.id;
                this.articleSearch = '';

                this.articleChanged();
            },

async generateCuttingPlanPdf() {
this.saveMessage = '';
this.saveError = '';

if (!this.selectedCategory) {
    this.$emit('added-error', 'Wybierz kategorię.');
    return;
}

if (!this.selectedArticle) {
    this.$emit('added-error', 'Wybierz artykuł.');
    return;
}

const items = this.orderItems
    .filter(item =>
        item.length !== '' &&
        item.length !== null &&
        item.quantity !== '' &&
        item.quantity !== null
    )
    .map(item => ({
        length: Number(item.length),
        quantity: Number(item.quantity)
    }));

if (!items.length) {
    this.$emit(
        'added-error',
        'Wprowadź przynajmniej jeden kompletny odcinek.'
    );
    return;
}

const invalidItem = items.some(item =>
    !Number.isInteger(item.length) ||
    item.length <= 0 ||
    !Number.isInteger(item.quantity) ||
    item.quantity <= 0
);

if (invalidItem) {
    this.$emit(
        'added-error',
        'Długość i ilość muszą być liczbami całkowitymi większymi od zera.'
    );
    return;
}

this.generatingPdf = true;

try {
    const response = await axios.post(
        this.route('creator.data.cutting-plan.pdf'),
        {
            project_id: this.project,
            team_name: this.team,
            liczba_maszyn: this.liczba_maszyn,
            kategoria: this.selectedCategory,
            article_id: this.selectedArticle,
            items: items
        }
    );

    const files = response.data.files;

    if (!Array.isArray(files) || files.length === 0) {
        throw new Error(
            'Nie otrzymano żadnych plików PDF.'
        );
    }

    for (const file of files) {
        const binary = window.atob(file.content);
        const bytes = new Uint8Array(binary.length);

        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }

        const blob = new Blob(
            [bytes],
            { type: 'application/pdf' }
        );

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = file.filename;

        document.body.appendChild(link);
        link.click();
        link.remove();

        // Nie zwalniaj URL przed rozpoczęciem pobierania.
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        }, 1000);
    }
} catch (error) {
    let message =
        error.message ||
        'Wystąpił błąd podczas generowania rozkroju.';

    const responseData = error.response?.data;

    if (responseData instanceof Blob) {
        try {
            const text = await responseData.text();
            const data = JSON.parse(text);

            if (data.errors) {
                message = Object.values(data.errors)
                    .flat()
                    .join(' ');
            } else if (data.message) {
                message = data.message;
            }
        } catch (e) {
            // Zachowaj komunikat domyślny.
        }
    } else if (responseData?.errors) {
        message = Object.values(responseData.errors)
            .flat()
            .join(' ');
    } else if (responseData?.message) {
        message = responseData.message;
    }

    this.saveError = message;
    this.$emit('added-error', message);
} finally {
    this.generatingPdf = false;
}

},


            async loadArticles() {
                this.selectedArticle = '';
                this.articles = [];
                this.articleSearch = '';

                this.saveMessage = '';
                this.saveError = '';

                if (!this.selectedCategory) {
                    return;
                }

                this.loadingArticles = true;

                try {
                    const response = await axios.get(
                        this.route(
                            'creator.settings.categories.articles',
                            this.selectedCategory
                        )
                    );

                    this.articles = response.data;

                } catch (error) {
                    this.articles = [];

                    this.saveError =
                        'Nie udało się pobrać listy artykułów.';

                } finally {
                    this.loadingArticles = false;
                }
            },

            articleChanged() {
                this.saveMessage = '';
                this.saveError = '';

                if (this.selectedArticle) {
                    this.$nextTick(() => {
                        this.focusLength(0);
                    });
                }
            },

            async saveOrder() {
                this.saveMessage = '';
                this.saveError = '';

                if (!this.selectedCategory) {
                    this.$emit(
                        'added-error',
                        'Wybierz kategorię.'
                    );

                    return;
                }

                if (!this.selectedArticle) {
                    this.$emit(
                        'added-error',
                        'Wybierz artykuł.'
                    );

                    return;
                }

                const items = this.orderItems
                    .filter(item =>
                        item.length !== '' &&
                        item.length !== null &&
                        item.quantity !== '' &&
                        item.quantity !== null
                    )
                    .map(item => ({
                        length: Number(item.length),
                        quantity: Number(item.quantity)
                    }));

                if (!items.length) {
                    this.$emit(
                        'added-error',
                        'Wprowadź przynajmniej jeden kompletny odcinek.'
                    );

                    return;
                }

                const invalidItem = items.some(item =>
                    !Number.isInteger(item.length) ||
                    item.length <= 0 ||
                    !Number.isInteger(item.quantity) ||
                    item.quantity <= 0
                );

                if (invalidItem) {
                    this.$emit(
                        'added-error',
                        'Długość i ilość muszą być liczbami całkowitymi większymi od zera.'
                    );

                    return;
                }

                this.saving = true;

                try {
                    const response = await axios.post(
                        this.route('creator.data.store'), {
                            project_id: this.project,
                            team_name: this.team,
                            liczba_maszyn: this.liczba_maszyn,
                            kategoria: this.selectedCategory,
                            article_id: this.selectedArticle,
                            items: items
                        }
                    );

                    this.saveMessage = response.data.message;
                    this.saveError = '';

                    this.resetOrderItems();

                    this.selectedCategory = '';
                    this.selectedArticle = '';
                    this.articles = [];
                    this.articleSearch = '';

                    this.$emit('added-article');

                    this.$emit(
                        'added-success',
                        'Zapotrzebowanie zostało poprawnie zapisane.'
                    );

                    this.hide();

                    this.$emit(
                        'close',
                        response.data.creator_id
                    );

                } catch (error) {
                    let message =
                        'Wystąpił błąd podczas zapisywania zapotrzebowania.';

                    if (error.response?.data?.errors) {
                        message = Object.values(
                                error.response.data.errors
                            )
                            .flat()
                            .join(' ');
                    } else if (error.response?.data?.message) {
                        message = error.response.data.message;
                    }

                    this.saveError = message;
                    this.saveMessage = '';

                    this.$emit(
                        'added-error',
                        message
                    );

                } finally {
                    this.saving = false;
                }
            },

			addOrderItem() {
				const lastItem =
					this.orderItems[this.orderItems.length - 1];

				if (
					!lastItem ||
					lastItem.length === '' ||
					lastItem.length === null ||
					lastItem.quantity === '' ||
					lastItem.quantity === null
				) {
					this.focusLength(
						this.orderItems.length - 1
					);

					return;
				}

				this.orderItems.push({
					id: Date.now() + Math.random(),
					length: '',
					quantity: ''
				});

				this.$nextTick(() => {
					this.focusLength(
						this.orderItems.length - 1
					);
				});
			},

            resetOrderItems() {
                this.orderItems = [{
                    id: 1,
                    length: '',
                    quantity: ''
                }];

                this.lengthRefs = [];
                this.quantityRefs = [];
            },

            resetForm() {
                this.selectedCategory = '';
                this.selectedArticle = '';
                this.articles = [];
                this.articleSearch = '';
                this.loadingArticles = false;
                this.saving = false;
                this.saveMessage = '';
                this.saveError = '';

                this.fileData = [];
                this.selectedFileData = [];
                this.loadingFileData = false;

                this.resetOrderItems();
            },

            setLengthRef(el, index) {
                if (el) {
                    this.lengthRefs[index] = el;
                }
            },

            setQuantityRef(el, index) {
                if (el) {
                    this.quantityRefs[index] = el;
                }
            },

            focusLength(index) {
                this.$nextTick(() => {
                    const input = this.lengthRefs[index];

                    if (input) {
                        input.focus();
                    }
                });
            },

            handleLengthTab(index, event) {
                if (event.shiftKey) {
                    return;
                }

                event.preventDefault();

                this.$nextTick(() => {
                    const input = this.quantityRefs[index];

                    if (input) {
                        input.focus();
                    }
                });
            },

            handleQuantityTab(index, event) {
                if (event.shiftKey) {
                    return;
                }

                if (index === this.orderItems.length - 1) {
                    event.preventDefault();
                    this.addOrderItem();
                }
            },

            show() {
                if (this.modalObj) {
                    this.modalObj.show();
                    this.loadFiles();
                }
            },

            hide() {
                if (this.modalObj) {
                    this.modalObj.hide();
                }
            }
        }
    };
</script>

<style scoped>
    h6 {
        font-size: 13px;
    }
</style>